import React, { useState, useEffect } from "react";
import Tables from "../../../../components/Tables/Tables";
import HeaderTable from "../../../../components/HeaderTable/HeaderTable";
import Modal from "../../../../components/Modal/Modal";
import { buttonsDefault } from "../../../../components/ButtonsTable/ButtonsTable";
import styled from "styled-components";
import {
  deleteTiposConjuntosAnalisis,
  getTiposConjuntosAnalisisPaginated,
  getTiposConjuntosAnalisisSearch,
} from "../../../../api/Configuracion";
import Toast from "../../../../components/Toast/Toast";
import Modal2 from "../../../../components/Modal/Modal";
import { CircularProgress } from "@mui/material";
const columns = [
  { id: "codigo", label: "Código" },
  { id: "descripcion", label: "Descripción" },
  { id: "habilitado", label: "Habilitado" },
  { id: "buttons" },
];

const TipoConjuntoDeAnalisis = () => {
  const [statusModal, setModalStatus] = useState(false);
  const [datosModal, setDatosModal] = useState("");
  const [tiposConjuntos, setTiposConjuntos] = useState([]);
  const [tiposConjuntosdId, setTiposConjuntosId] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [itemsCount, setItemsCount] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [statusModal2, setModalStatus2] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    fetchTiposConjuntosAnalisisPaginated(paginaActual, orderBy, searchTerm,"primera");
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaActual, orderBy]); // Ignorando fetchTiposConjuntosAnalisisPaginated y searchTerm en la dependencia array

  const fetchTiposConjuntosAnalisisPaginated = async(pagina, order, search,action) => {
    const res = await getTiposConjuntosAnalisisPaginated(pagina, order, search);
    setPageCount(res.data.totalPages);
    setItemsCount(res.data.totalItems);

    if (action === "new") {
      if (res.data.items.length + 1 === 21) {
        setPaginaActual(res.data.totalPages);
      }
    } else if (action === "delete") {
      setTimeout(() => {
        setSuccess(false);
      }, 1000)
    } else {
      if (res.data.totalPages === 0) {
        setPaginaActual(1);
      } else if (res.data.totalPages < paginaActual) {
        setPaginaActual(res.data.totalPages);
      } else {
        setPaginaActual(paginaActual);
      }
    }

    setTiposConjuntos(
      res.data.items.map((res) => {
        return {
          id: res.id,
          codigo: res.codigo_tpcana,
          descripcion: res.desc_tpcana,
          habilitado: res.status,
        };
      })
    );
  }

  const handleClickButonTable = (value, valueRow) => {
    if (value !== "Eliminar") {
      setModalStatus(true);
      setDatosModal({ button: value.toLowerCase(), datos: valueRow });
    } else {
      //handleDelete(valueRow.id)
      setTiposConjuntosId(valueRow.id);
      setModalStatus2(true);
    }
  };

  const handleDelete = (id) => {
    setIsLoading(true);
    // setSuccess(false);
    deleteTiposConjuntosAnalisis(id)
      .then(() => {
        setIsLoading(false);
        setTiposConjuntosId("");
        setSuccess(true);
        setMsjToast("Tipo de Conjunto de Análisis eliminado con exito.");
        setKey(key + 1);
        
        const paginaActualTemp = tiposConjuntos.length === 1 && paginaActual > 1 ? paginaActual - 1 : paginaActual;
        setPaginaActual(paginaActualTemp);
        
        return fetchTiposConjuntosAnalisisPaginated(
          paginaActualTemp,
          orderBy,
          searchTerm,
          "delete"
        );
      })
      .catch((err) => {
        setIsLoading(false);
        setMsjToast("Error al eliminar El tipo de Conjunto de Analisis");
        setError(true);
      });
  };

  const handleClickButtonHeader = () => {
    setDatosModal("");
    setModalStatus(true);
  };

  const handleOrder = (value) => {
    let valor;
    if (orderBy === "" || orderBy.replace("-", "").length !== value.length) {
      valor = value;
    } else {
      valor = orderBy;
    }

    if (valor.indexOf("-") > -1) {
      const updatedValue = valor.replace("-", "");
      setOrderBy(updatedValue);
    } else {
      const updatedValue = "-" + valor;
      setOrderBy(updatedValue);
    }
  };

   const handleBuscador = (value) => {
    setSearchTerm(value);
    fetchTiposConjuntosAnalisisPaginated(paginaActual, orderBy, value, "search");
  };

  return (
    <Styled >
        {isLoading &&
        <CircularProgress size={30}
          sx={{
            position: "fixed",
            bottom: "0",
            padding: "10px",
            zIndex: "9999"
          }}
        />
      }
      {success && (
        <Toast key={key} title={msjToast} close={() => setSuccess(false)} />
      )}
      {error && (
        <Toast
          key={key}
          type={"error"}
          title={msjToast}
          close={() => setError(false)}
        />
      )}
      <Modal
        datos={datosModal}
        isOpen={statusModal}
        type={"tipoConjuntoAnalisis"}
        onClose={({ msj, status }) => {
          setSuccess(false);
          setError(false);
          if (status === "success") {
            setSuccess(true);
            setMsjToast(msj);
            fetchTiposConjuntosAnalisisPaginated(
              paginaActual,
              orderBy,
              searchTerm,
              msj.includes("cread") ? "new" : ""
            )
          } else if (status === "error") {
            setError(true);
            setMsjToast(msj);
          } else{
            fetchTiposConjuntosAnalisisPaginated(
              paginaActual,
              orderBy,
              searchTerm,
              "ver"
            )
          }
          setTimeout(() => {
            setSuccess(false);
            setError(false); 
            setMsjToast(''); 
          }, 1000)
          setModalStatus(false);
        }}
      />

      <HeaderTable
        styledHead="cfg"
        cfg
        title="Tipo de Conjunto de Análisis"
        value={searchTerm}
        valueBuscador={(value) => handleBuscador(value)}
        isClearable={() => { handleBuscador("") }}
        labelButton={"Nuevo tipo de conjunto de análisis"}
        onClickButton={() => {
          handleClickButtonHeader();
        }}
        search
      />

      <Tables
        typeTable={"prop"}
        columns={columns}
        rows={tiposConjuntos}
        cRows={20}
        pagination={true}
        onClickSwitch={(value) => {
          handleOrder(value);
        }}
        page={(e) => setPaginaActual(e + 1)}
        pages={pageCount}
        actualpage={paginaActual}
        totalRows={itemsCount}
        // valueBuscador={valueBuscador}
        buttons={buttonsDefault}
        onClickButtonTable={(value, valuesRow) => {
          handleClickButonTable(value, valuesRow);
        }}
      />
      <Modal2
        type="eliminar"
        isOpen={statusModal2}
        onClose={() => setModalStatus2(false)}
        onClickSuccess={() => {
          setModalStatus2(false);
          handleDelete(tiposConjuntosdId);
        }}
      ></Modal2>
    </Styled>
  );
};

export default TipoConjuntoDeAnalisis;

const Styled = styled.div`
  padding: 20px;
  margin: auto;
  .styledTables {
    //height: 100vh;
  }
`;
